import Page from "framework/ui/content/Page";
import Head from "framework/ui/content/Head";
import NavBar from "framework/ui/content/NavBar";
import PageContent from "framework/ui/content/PageContent";
import PageTitle from "framework/ui/content/PageTitle";
import PageSections from "framework/ui/content/PageSections";
import Copyright from "framework/ui/content/Copyright";
import Logo from "framework/ui/content/Logo";
import logo from "./assets/logo.PNG";
import logo_sm from "./assets/logo_sm.png";

import "./css/NavBar.css"
import "./css/Site.css"
import PageNavigation from "framework/ui/content/PageNavigation";

/**
 * @typedef MyPageProps
 *
 * @property {number} [pageId]  Specific page ID to display.
 */

/**
 * Component for site-specific page contents.
 *
 * @param props {MyPageProps}
 * @returns {JSX.Element}
 * @constructor
 */
export default function MyPage(props) {
  return (
    <Page {...props}>
      <Head/>
      <Logo
        src={logo}
        className="d-none d-md-flex"
      />
      <NavBar
        icon={logo_sm}
        brandClassName={'d-md-none'}
        expand={'md'}
      />
      <PageContent>
        <PageTitle/>
        <PageSections/>
      </PageContent>
      <PageNavigation/>
      <Copyright startYear={'2015'}/>
    </Page>
  )
}